import { FiZap, FiDollarSign, FiPlay } from 'react-icons/fi';
import { HiOutlineDeviceMobile } from 'react-icons/hi';

export default function MobileSection() {
  return (
    <section className="section mobile-section">
      <div className="container">
        <div className="mobile-grid">

          {/* Left Content */}
          <div className="mobile-content">
            <div className="mobile-badge">
              <HiOutlineDeviceMobile className="badge-icon" />
              <span>Mobile-first design</span>
            </div>

            <h2 className="mobile-title">
              Predict anywhere,<br />
              <span className="text-gradient">anytime</span>
            </h2>

            <p className="mobile-description">
              VideoRoyale is optimized for mobile. Browse battles, place predictions, and track your wins on the go.
            </p>

            <div className="mobile-features">
              <div className="feature-item">
                <div className="feature-icon theme-purple">
                  <FiZap />
                </div>
                <div className="feature-text">
                  <h4>Lightning-fast predictions</h4>
                  <p>Place your bet in seconds with optimized mobile UX</p>
                </div>
              </div>

              <div className="feature-item">
                <div className="feature-icon theme-cyan">
                  <FiDollarSign />
                </div>
                <div className="feature-text">
                  <h4>USDC wallet integration</h4>
                  <p>Connect your mobile wallet and start betting instantly</p>
                </div>
              </div>

              <div className="feature-item">
                <div className="feature-icon theme-yellow">
                  <FiPlay />
                </div>
                <div className="feature-text">
                  <h4>Swipe-to-predict interface</h4>
                  <p>Intuitive gestures make predicting feel like a game</p>
                </div>
              </div>
            </div>
          </div>

          {/* Right Visual (Phone Mockup) */}
          <div className="mobile-visual">
            <div className="phone-glow"></div>
            <div className="phone-mockup">
              <div className="phone-notch"></div>
              <div className="phone-screen">
                {/* Status Bar */}
                <div className="status-bar">
                  <span>9:41</span>
                  <div className="status-icons">
                    <div className="signal-icon"></div>
                    <div className="battery-icon"></div>
                  </div>
                </div>

                {/* App Content */}
                <div className="app-content">
                  <div className="app-header">
                    <span className="label">Active predictions</span>
                    <h3>VideoRoyale</h3>
                  </div>

                  {/* Video Card */}
                  <div className="app-card video-card">
                    <div className="video-placeholder">
                      <div className="play-button">
                        <FiPlay />
                      </div>
                      <span className="duration-badge">2:34</span>
                      <div className="views-badge">Current: 127k views</div>
                    </div>
                  </div>

                  {/* Betting Interface */}
                  <div className="app-card betting-card">
                    <p className="bet-question">How many views will this reach?</p>
                    <div className="bet-options">
                      <div className="bet-option selected">
                        <span className="range">0-100k</span>
                        <span className="multiplier">1.8x</span>
                      </div>
                      <div className="bet-option">
                        <span className="range">100k-500k</span>
                        <span className="multiplier">2.8x</span>
                      </div>
                    </div>
                    <button className="app-btn-primary">Predict now</button>
                  </div>

                  {/* Stats Row */}
                  <div className="stats-row">
                    <div className="mini-stat">
                      <span className="label">Wins</span>
                      <span className="value">24</span>
                    </div>
                    <div className="mini-stat">
                      <span className="label">Earned</span>
                      <span className="value text-cyan">$840</span>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
